import { ApiRayquazaApi } from '@/utils/axios';

export type Customer = {
  id?: string;
  name: string;
  email: string;
  identification_number: number;
  phone: string;
  address: string;
  type_document_identification_id: string;
  type_organization_id: string;
  municipality_id: string;
  type_regime_id: string;
  created_at?: Date;
};

export const getCustomers = (params: Record<string, unknown>) => async () => {
  const { data } = await ApiRayquazaApi.get(`/customers`, {
    params,
  });
  return data ?? [];
};

export const createCustomer = async (data: Customer) => {
  const response = await ApiRayquazaApi.post(`/customers`, data);
  return response.data;
};
